import { useMemo } from 'react';

export default function useStateFilterOptions(opportunities) {
  return useMemo(
    () => [...new Set(opportunities.map(o => o.stateCodes).flat())].sort().map((s, i) => ({ id: i, description: s })),
    [opportunities]
  );
}
